export const projects = {
  en: {
    title: 'Projects',
    items: {
      assessorai: {
        title: 'AssessorAI',
        description: 'INPI registered system that automates legal analysis with LLMs and RAG pipeline, using LangChain and OpenAIEmbeddings.',
        url: 'https://revistas.inpi.gov.br/pdf/Programa_de_computador2827.pdf'
      },
      helpu: {
        title: 'HelpU',
        description: 'Prototyping application for radiographic diagnostic support with CNNs, approved in the 13th edition of Campus Mobile.',
        url: 'https://www.institutoclaro.org.br/nossas-novidades/conheca-os-projetos-selecionados-para-a-13a-edicao-do-campus-mobile/'
      },
      reciclahub: {
        title: 'ReciclaHub',
        description: 'Sustainability app with scheduling features, gamification, and intelligent selective collection routes.',
        url: 'https://reciclahub.nebulaweb.com.br/'
      },
      facial_recognition: {
        title: 'Facial Recognition with Keras',
        description: 'Face classifier using CNNs with LFW and Olivetti datasets, focusing on preprocessing and model optimization.',
        url: 'https://github.com/charlierf/hands-on-ml-face-recognition'
      }
    }
  },
  pt: {
    title: 'Projetos',
    items: {
      assessorai: {
        title: 'AssessorAI',
        description: 'Sistema registrado no INPI que automatiza análises jurídicas com LLMs e pipeline RAG, utilizando LangChain e OpenAIEmbeddings.',
        url: 'https://revistas.inpi.gov.br/pdf/Programa_de_computador2827.pdf'
      },
      helpu: {
        title: 'HelpU',
        description: 'Aplicativo em prototipagem para suporte a diagnósticos radiográficos com CNNs, aprovado na 13ª edição da Campus Mobile.',
        url: 'https://www.institutoclaro.org.br/nossas-novidades/conheca-os-projetos-selecionados-para-a-13a-edicao-do-campus-mobile/'
      },
      reciclahub: {
        title: 'ReciclaHub',
        description: 'App para sustentabilidade com funcionalidades de agendamento, gamificação e rotas inteligentes de coleta seletiva.',
        url: 'https://reciclahub.nebulaweb.com.br/'
      },
      facial_recognition: {
        title: 'Reconhecimento Facial com Keras',
        description: 'Classificador de rostos utilizando CNNs com datasets LFW e Olivetti, com foco em pré-processamento e otimização de modelos.',
        url: 'https://github.com/charlierf/hands-on-ml-face-recognition'
      }
    }
  }
};